<template>
  <div>
    <span
      class="badge badge-pill"
      :class="{
        'badge-soft-light': isChatStatusNew,
        'badge-soft-primary': isChatStatusChat,
        'badge-soft-success': isChatStatusResolved,
      }"
    >
      <template v-if="isChatStatusNew">
        {{ $t('room.status.new') }}
      </template>
      <template v-else-if="isChatStatusChat">
        {{ $t('room.status.chat') }}
      </template>
      <template v-else-if="isChatStatusResolved">
        {{ $t('room.status.resolved') }}
      </template>
    </span>
  </div>
</template>

<script>
import {ChatStatusChat, ChatStatusNew, ChatStatusResolved} from "../../../../services/chat/const";

export default {
  name: 'StatusRoomsComponents',
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isChatStatusNew() {
      return this.room.status === ChatStatusNew;
    },
    isChatStatusChat() {
      return this.room.status === ChatStatusChat;
    },
    isChatStatusResolved() {
      return this.room.status === ChatStatusResolved;
    },
  },
}
</script>
